import { gql } from '@apollo/client'

export const PUBLISH_POST = gql`
  mutation PublishPost($input: PublishPostInput!) {
    publishPost(input: $input) {
      post {
        id
        text
        status
        editedAt
        editable
        linkUrl
        linkTitle
        photos {
          id
          url
        }
      }
      errors
    }
  }
`
